import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = t("marquee");
  const row = [...items, ...items];
  return (
    <div
      data-testid="competency-marquee"
      className="relative overflow-hidden border-y border-[#262930] bg-[#121418] py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-tech text-xs uppercase tracking-[0.15em] text-[#9E9E9E] px-8">
                  {item}
                </span>
                <span className="h-1 w-1 rounded-full bg-[#C87A5B]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
